import RestorePasswordForm from "../../components/personal/RestorePasswordPage/RestorePasswordForm";

const RestorePasswordPage = () => {
    return(
        <>
        <div>
            <RestorePasswordForm/>
        </div>
        </>
    )
}

export default RestorePasswordPage;